/**
 * Static contact details — no backend required.
 * Update WhatsApp number here to change it site-wide.
 */
export const contactInfo = {
  whatsapp: '+27 82 623 0181',
  email: 'info@dubeboxing.co.za',
  address: 'Mahalefele road, johannesburg, south africa 1801',
  /** Optional: more precise Google Maps search (e.g. business name). Uses address if omitted. */
  // mapQuery: 'Dube Boxing Club, Mahalefele Road, Johannesburg',
};

export const defaultWhatsAppMessage =
  'Hello! I would like to know more about your boxing club services.';
